export function normalizeOrderStatus(status) {
  if (!status) return '';
  const n = String(status).trim().toLowerCase().replace(/\s+/g, '_');
  /* The API's own enum (fleetApi ORDER_STATUS, id 3) is the single word
     'enroute'. Whitespace normalisation alone could never turn that into
     'en_route', so the busiest status in the app fell through every lookup:
     getStatusBadge gave it the same grey as 'cancelled' and printed the raw
     'ENROUTE', while the Orders page's own label map said 'En Route'. The
     table badge and the PDF export disagreed on the same row. */
  return n === 'enroute' ? 'en_route' : n;
}

export function isRouteStatus(status) {
  const normalized = normalizeOrderStatus(status);
  return normalized === 'in_transit' || normalized === 'en_route';
}

export function isClosedOrderStatus(status) {
  const normalized = normalizeOrderStatus(status);
  return normalized === 'completed' || normalized === 'cancelled';
}

export function isActiveAssignedOrder(order) {
  if (!order?.vehicleId) return false;
  return !isClosedOrderStatus(order.status);
}

export function formatTrackingOrderStatus(status) {
  if (isRouteStatus(status)) return 'On Route';
  return String(status || '').replace(/_/g, ' ');
}
